import React from 'react';
import { Box, CardContent, Typography, Tooltip, Skeleton } from '@mui/material';
import OverlayLoader from '../OverlayLoader';
import { BaseCard, BaseCardHeader } from '../Common/BaseCard';

const CardValue = ({ children, isLoading, tooltipTitle = '', ...rest }) => (
  <Tooltip title={tooltipTitle} sx={{ color: '#495057', lineHeight: 1.2, letterSpacing: -2 }}>
    <Typography variant="h3" component="div" {...rest}>
      {isLoading ? <Skeleton width={120} /> : children}
    </Typography>
  </Tooltip>
);

const StyledBaseCard = (props) => <BaseCard {...props} sx={{ height: '100%' }} />;

const CardDiffValue = ({ children, isLoading, tooltipTitle = '', ...rest }) => (
  <Tooltip title={tooltipTitle} sx={{ lineHeight: 1.2, float: 'right', letterSpacing: -2 }}>
    <Typography variant="h4" component="div" {...rest}>
      {isLoading ? <Skeleton width={70} /> : children}
    </Typography>
  </Tooltip>
);

export const cardColors = {
  '-1': '#d92550',
  '0': '#30b1ff',
  '1': '#3ac47d',
};

export const DashboardCard = ({
  title,
  totalValue,
  currentValue,
  totalValueTooltip = '',
  currentValueTooltip = '',
  isLoading,
}) => {
  return (
    <OverlayLoader isLoading={isLoading} wrapperStyles={{ height: '100%' }}>
      <StyledBaseCard>
        <BaseCardHeader titleTypographyProps={{ variant: 'subtitle1', color: 'textSecondary' }} title={title} />
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="flex-end" flexWrap="nowrap" columnGap={1}>
            <Box flexGrow={1}>
              <CardValue isLoading={isLoading} tooltipTitle={totalValueTooltip}>
                {totalValue}
              </CardValue>
            </Box>
            {currentValue && currentValue.value !== null && (
              <Box flexGrow={1}>
                <CardDiffValue isLoading={isLoading} tooltipTitle={currentValueTooltip}>
                  <Box color={currentValue.color}>{currentValue.value}</Box>
                </CardDiffValue>
              </Box>
            )}
          </Box>
        </CardContent>
      </StyledBaseCard>
    </OverlayLoader>
  );
};
